import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useAuth } from '@fourthwall/auth'
import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'

import { routing } from '../utils/routing'
import { useCurrentShop } from './Dashboard/hooks/useCurrentShop'

const configuration: { [key: string]: { redirectTo: string | undefined } } = {
  'tiktok-partner': {
    redirectTo: routing.apps.tiktokShop,
  },
}

const getAppSettingsReturnUrl = (app: string | undefined, baseUri: string) => {
  if (!app) throw new Error(`Unknown app: ${app}`)
  if (!(app in configuration)) throw new Error(`Unknown app: ${app}`)

  const config = configuration[app]
  if (!config.redirectTo) return undefined

  return new URL(config.redirectTo, baseUri).toString()
}

const connectToApp = (app: string, token: string, baseUri: string) => {
  const returnUrl = getAppSettingsReturnUrl(app, baseUri)
  const url = CreatorIntegrationsApiClient.appAuthorizationUrl({ app, token, returnUrl })
  window.location.assign(url)
}

export const AppRedirect = () => {
  const { app } = useParams<'app'>()
  const { keycloak } = useAuth()
  const { currentShop } = useCurrentShop()

  useEffect(() => {
    if (!app || !keycloak?.token || !currentShop?.baseUri) return
    connectToApp(app, keycloak.token, currentShop.baseUri)
  }, [app, keycloak?.token, currentShop?.baseUri])

  return null
}
